import API_BASE_URL from "../utils/config";
import request from "../utils/request";
import { v4 as uuidv4 } from "uuid";

export async function httpGetQuestions(data) {
  const url = `${API_BASE_URL}/questions`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function httpGetQuestion(data) {
  const url = `${API_BASE_URL}/questions/${data}`;
  return request({
    url,
    method: "get",
  });
}

export async function httpCreateQuestion(data) {
  const url = `${API_BASE_URL}/questions`;
  return request({
    url,
    method: "post",
    data,
  });
}

export async function httpEditQuestion(data) {
  const url = `${API_BASE_URL}/questions/${data?.id}`;
  return request({
    url,
    method: "put",
    data,
  });
}

export async function httpDeleteQuestion(data) {
  const url = `${API_BASE_URL}/questions/${data}`;
  return request({
    url,
    method: "delete",
  });
}

export async function httpCreateQuestionImage(data) {
  const modData = { image: data, name: uuidv4() };
  const url = `${API_BASE_URL}/images`;
  const formData = toFormData(modData);
  return request({
    url,
    method: "post",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}

export async function httpUploadBulkQuestions(data) {
  const url = `${API_BASE_URL}/questions/bulk-upload?paperId=${data.paperId}`;
  const formData = data.formData;
  return request({
    url,
    method: "post",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}

export async function httpGenerateQuestions(data) {
  const { questionsCount, questionType, optionsCount, formData, paperId , query} = data;
  const url = `${API_BASE_URL}/ai-questions/v2?questionsCount=${questionsCount}&query=${query}&questionType=${questionType}&optionsCount=${optionsCount}&paperId=${paperId}`;

  return request({
    url,
    method: "post",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}
export async function httpAddKnowledge(data) {
  const { paperId , paperName, formData} = data;
  const url = `${API_BASE_URL}/ai-questions/add-knowledge?paperName=${paperName}&paperId=${paperId}`;

  return request({
    url,
    method: "post",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}

export async function httpSaveGeneratedQuestions(data) {
  const { paperId, questions } = data;
  const url = `${API_BASE_URL}/ai-questions/save?paperId=${paperId}`;
  return request({
    url,
    method: "post",
    data: questions,
  });
}

function toFormData(data) {
  const formData = new FormData();
  formData.append("file", data.image);
  formData.append("name", data.name);
  return formData;
}
export async function httpGetSchools(data) {
  const url = `${API_BASE_URL}/schools`;
  return request({
    url,
    method: "get",
    data,
  });
}
